
















import Vue from 'vue';
//import ContentAd from '@/components/Sidebar/ContentAd.vue'
import NewsItem from '@/components/Sidebar/NewsItem.vue'

export default Vue.extend({
  name: 'Sidebar',
  components: {
    //ContentAd,
    NewsItem
  },
  data(){
    return {
      maxItems: this.num || 5
    }
  },
  props: [
    "num"
  ],
  created() {
    this.$store.dispatch("loadRSS");
  },
  computed: {
    newsitems: function(): Array<any> {
      return this.$store.state.newsitems.slice(0,this.maxItems);
    }
  }
});
